// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TabWidget_tabs__3-R7Q","emptyTab":"TabWidget_emptyTab__F26aO","widget":"TabWidget_widget__2RPyo"};